import QuoteList from "./features/list/QuoteList";

export default QuoteList;
